import {GetterTree} from "vuex";
import {SmppConnectionState} from "@/store/settings/smpp_connections/types";
import {RootState} from "@/store/types";

export const getters: GetterTree<SmppConnectionState, RootState> = {
  smppConnections:state => state.smppConnections,
  smppConnectionItem:state => state.smppConnectionItem,
  serverNames:state => state.serverNames
}